import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Card, Button, Modal, Spinner, ListGroup } from 'react-bootstrap'
import LogoSVG from './logoSVG'

export default class Transaction extends Component {
  constructor (props) {
    super(props)
    this.state = {
      waitingTime: this.calculateWaitingTime(),
      isValidating: false,
      showArticleModal: false
    }
  }

  handleValidate = () => {
    this.setState({ isValidating: true })
    setTimeout(() => {
      this.props.onValidate(
        this.props.transaction.id,
        this.props.transaction.id_lieu
      )
    }, 800)
  }

  handleArticleClick = () => {
    this.setState({ showArticleModal: true })
    this.props.onRequestArticles(
      this.props.transaction.id,
      this.props.transaction.id_lieu
    )
  }

  handleCloseArticleModal = () => {
    this.setState({ showArticleModal: false })
    this.props.onClearArticles()
  }

  handleSelectArticle = (articleId) => {
    this.props.onChangeArticle(
      this.props.transaction.id,
      this.props.transaction.id_lieu,
      articleId
    )
    this.setState({ showArticleModal: false })
    this.props.onClearArticles()
  }

  componentDidMount () {
    this.timerInterval = setInterval(() => {
      this.setState({ waitingTime: this.calculateWaitingTime() })
    }, 1000)
  }

  componentWillUnmount () {
    if (this.timerInterval) {
      clearInterval(this.timerInterval)
    }
  }

  calculateWaitingTime () {
    let epoch = this.props.transaction.epoch
    if (epoch > 1e12) epoch = epoch / 1000
    const nowSeconds = Date.now() / 1000
    return Math.floor(nowSeconds - epoch)
  }

  formatWaitingTime () {
    const seconds = this.state.waitingTime

    if (seconds < 0) return '0s'
    if (seconds < 60) return `${seconds}s`
    if (seconds < 900) { // 15 minutes = 900 seconds
      const mins = Math.floor(seconds / 60)
      const secs = seconds % 60
      return `${mins}:${secs.toString().padStart(2, '0')}`
    }
    return '>15min'
  }

  btnVariant () {
    if (this.props.transaction.owner == '') return 'success'

    if (this.props.transaction.owner == 'self') return 'danger'

    return 'warning'
  }

  btnDisabled () {
    if (
      this.props.transaction.owner != '' &&
      this.props.transaction.owner != 'self'
    )
      return true
    else return false
  }

  btnText () {
    if (this.props.transaction.owner == 'self') return 'Libérer'

    if (this.props.transaction.owner == '') return "S'en occuper"

    return 'En chargement'
  }

  render () {
    const isDisabled = this.props.disabled
    const { isValidating } = this.state
    const cardStyle = {
      width: '22rem',
      position: 'relative',
      ...(isDisabled && {
        opacity: 0.5,
        pointerEvents: 'none',
        filter: 'grayscale(50%)'
      })
    }

    const overlayStyle = {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(40, 167, 69, 0.85)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 10,
      borderRadius: 'inherit',
      animation: 'fadeIn 0.3s ease-in-out'
    }

    const checkmarkStyle = {
      color: 'white',
      fontSize: '8rem',
      fontWeight: 'bold',
      animation: 'scaleIn 0.4s ease-out'
    }

    return (
      <>
        <style>
          {`
            @keyframes fadeIn {
              from { opacity: 0; }
              to { opacity: 1; }
            }
            @keyframes scaleIn {
              from { transform: scale(0); opacity: 0; }
              to { transform: scale(1); opacity: 1; }
            }
          `}
        </style>
        <Card style={cardStyle}>
          {isValidating && (
            <div style={overlayStyle}>
              <span style={checkmarkStyle}>✓</span>
            </div>
          )}
          <Card.Header>
            <div className='d-flex flex-row justify-content-between align-items-center'>
              <div>
                <h1>{this.props.transaction.camion}</h1>
              </div>
              <div className='d-flex flex-row'>
                {
                  {
                    CHARGE: (
                      <>
                        <LogoSVG letter='C' color='#13eb2a' />{' '}
                        {this.props.transaction.with_decharge == true && (
                          <LogoSVG letter='D' color='#eb1316' />
                        )}
                      </>
                    ),
                    DECHARGE: <LogoSVG letter='D' color='#eb1316' />,
                    default: <LogoSVG letter='?' color='#aeaeae' />
                  }[this.props.transaction.transaction]
                }
              </div>
            </div>
          </Card.Header>
          <Card.Body>
            <Card.Title>
              <div>{this.props.transaction.quantity}</div>
              <div>
                <span
                  style={{ cursor: 'pointer', color: '#0d6efd', textDecoration: 'underline' }}
                  onClick={this.handleArticleClick}
                >
                  {this.props.transaction.article}
                </span>
              </div>
            </Card.Title>
            <Card.Subtitle></Card.Subtitle>
            <p className='mb-0'>{this.props.transaction.client}</p>
            <p>{this.props.transaction.chantier}</p>

            {this.props.transaction.allow_btn_ownership !== false && (
              <div className='d-flex flex-row justify-content-between align-content-center align-items-center'>
                <div>
                  {this.props.transaction.owner_description == ''
                    ? 'Pas de machine attribuée'
                    : this.props.transaction.owner_description}
                </div>

                <div>
                  <Button
                    disabled={this.btnDisabled()}
                    variant={this.btnVariant()}
                    onClick={() => {
                      this.props.onToggleOwnership(
                        this.props.transaction.id,
                        this.props.transaction.id_lieu
                      )
                    }}
                  >
                    {this.btnText()}
                  </Button>
                </div>
              </div>
            )}

            <Button
              variant='success'
              disabled={isValidating || this.btnDisabled()}
              onClick={this.handleValidate}
            >
              Valider le chargement
            </Button>
          </Card.Body>
          <Card.Footer>
            <div className='d-flex flex-row justify-content-between align-items-center'>
              <div>
                <div>
                  {this.props.transaction.datetime}
                </div>
                <div style={{ fontVariantNumeric: 'tabular-nums' }}>
                  Temps d'attente : <strong>{this.formatWaitingTime()}</strong>
                </div>
              </div>
              <div>
                <Link
                  to='/photos'
                  state={{
                    images: this.props.transaction.images,
                    id: this.props.transaction.id,
                    id_lieu: this.props.transaction.id_lieu
                  }}
                >
                  {this.props.transaction.images.length === 0 ? (
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='24'
                      height='24'
                      fill='#6c757d'
                      viewBox='0 0 16 16'
                    >
                      <path d='M2.146 2.854a.5.5 0 1 1 .708-.708L11.646 11l2.5 2.5a.5.5 0 0 1-.708.708l-2.5-2.5L2.146 2.854zM2 13.5A1.5 1.5 0 0 1 .5 12V4A1.5 1.5 0 0 1 2 2.5h.172a.5.5 0 0 1 .354.146L5.06 5.18a.5.5 0 0 0 .354.146H9.5a.5.5 0 0 1 .5.5v1.5l-1 1V6.5a.5.5 0 0 0-.5-.5H5.06a.5.5 0 0 1-.354-.146L2.172 3.32a.5.5 0 0 0-.354-.146H2a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h9.086l1 1H2zm9.5-2.5L13 9.5V12a1.5 1.5 0 0 1-1.5 1.5h-1.086l-1-1H11.5a.5.5 0 0 0 .5-.5v-1zm1.5-4.5V4A1.5 1.5 0 0 0 11.5 2.5h-7L5.5 3.5h6a.5.5 0 0 1 .5.5v2l1-1z'/>
                    </svg>
                  ) : (
                    <>
                      {this.props.transaction.images.length === 1 ? (
                        <>1 photo</>
                      ) : (
                        <>{this.props.transaction.images.length} photos</>
                      )}
                    </>
                  )}
                </Link>
              </div>
            </div>
          </Card.Footer>
        </Card>

        <Modal show={this.state.showArticleModal} onHide={this.handleCloseArticleModal} centered>
          <Modal.Header closeButton>
            <Modal.Title>Changer l'article</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {!this.props.availableArticles ? (
              <div className='text-center py-4'>
                <Spinner animation='border' variant='primary' />
                <p className='mt-2 mb-0'>Chargement des articles...</p>
              </div>
            ) : (
              <ListGroup>
                {this.props.availableArticles.articles.map((article) => (
                  <ListGroup.Item
                    key={article.id}
                    action
                    onClick={() => this.handleSelectArticle(article.id)}
                    active={article.description === this.props.transaction.article}
                  >
                    {article.description}
                  </ListGroup.Item>
                ))}
              </ListGroup>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant='secondary' onClick={this.handleCloseArticleModal}>
              Annuler
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    )
  }
}
